import {makeStyles} from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
   root: {
      margin: '0 1rem',
      '& > p': {
         marginBottom: '1rem',
      },
      '& img': {
         width: 200,
         height: 200,
      },
   },
}));
